import { Checkbox, Field, Select } from "components/shared/form";
import { scenarioAnswerValueTypesEnum, scenarioQuestionTypesEnum } from "helpers/enums";
import React from "react";
import ScenarioAnswersForm from "../scenarioAnswerOptions/index";
import { config } from "./config";

const ScenarioQuestionForm = (props) => {
    const { scenarioQuestion, onChange, questionOptions } = props;
    const {
        text,
        onlyNewPhotos,
        nextQuestionId,
        questionType,
        answerValueType,
        minValueCondition,
        maxValueCondition,
        externalData,
    } = config;
    return (
        <>
            <Field {...text} onChange={onChange} value={scenarioQuestion.text} />
            <Select {...questionType} onChange={onChange} value={scenarioQuestion.questionType} />
            <Field
                {...externalData.config.propertyName}
                onChange={({ name, value }) =>
                    onChange({ name: "externalData", value: { ...scenarioQuestion.externalData, [name]: value } })
                }
                value={scenarioQuestion.externalData?.propertyName || ""}
            />
            {scenarioQuestion.questionType === scenarioQuestionTypesEnum.Value && (
                <>
                    <Select {...answerValueType} onChange={onChange} value={scenarioQuestion.answerValueType} />
                    {[scenarioAnswerValueTypesEnum.Integer, scenarioAnswerValueTypesEnum.Double].includes(
                        scenarioQuestion.answerValueType,
                    ) && (
                        <>
                            <Field
                                {...minValueCondition}
                                onChange={onChange}
                                value={scenarioQuestion.minValueCondition}
                            />
                            <Field
                                {...maxValueCondition}
                                onChange={onChange}
                                value={scenarioQuestion.maxValueCondition}
                            />
                        </>
                    )}
                </>
            )}
            {scenarioQuestion.answerValueType === scenarioAnswerValueTypesEnum.File && (
                <Checkbox {...onlyNewPhotos} onChange={onChange} value={scenarioQuestion.onlyNewPhotos} />
            )}
            {[
                scenarioQuestionTypesEnum.Instruction,
                scenarioQuestionTypesEnum.Value,
                scenarioQuestionTypesEnum.SelectMultiple,
            ].includes(scenarioQuestion.questionType) && (
                <Select
                    {...nextQuestionId}
                    onChange={onChange}
                    value={scenarioQuestion.nextQuestionId}
                    options={questionOptions}
                />
            )}
            {[scenarioQuestionTypesEnum.SelectOne, scenarioQuestionTypesEnum.SelectMultiple].includes(
                scenarioQuestion.questionType,
            ) && <ScenarioAnswersForm editMode {...props} />}
        </>
    );
};

export default ScenarioQuestionForm;
